<c-card class="mb-5">
    <c-card-header>
        <!-- <div class="d-flex justify-content-between align-items-center py-2"> -->
            <!-- <app-date-to-date-search (dateToDateSearch)="dateToDateSearch($event)"></app-date-to-date-search> -->
            <!-- <c-button-group class="btn btn-primary" role="group"> -->
                <!-- <button cButton class="btn-primary" (click)="handleDoc('pdf')">PDF</button>
                <button cButton class="btn-primary" (click)="handleDoc('csv')">CSV</button> -->
                <!-- <button cButton class="btn-primary" (click)="handleDoc('xls')">XLS</button>
            </c-button-group> -->
        <!-- </div> -->
    </c-card-header>    
    <c-card-body>
        <div class="mt-4">
  <h5 class="mb-3">Exchange History</h5>
  <div class="table-responsive">
    <table class="table table-bordered text-center">
      <thead class="thead-light">
        <tr>
          <th>Token</th>
          <th *ngFor="let exchange of exchanges">{{ exchange }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let token of tokens">
          <td>{{ token }}</td>
          <td *ngFor="let exchange of exchanges">
            {{ getData(token, exchange) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</c-card-body>
</c-card>